import React from 'react';
import { User } from '../../types';
import GameMenu from './GameMenu';
import UserProfile from './UserProfile';

interface GameLayoutProps {
  user: User;
  onMenuClick: (page: 'main' | 'gta' | 'travel' | 'garage' | 'drugs' | 'crimes' | 'users-online' | 'jail' | 'blackjack' | 'roulette' | 'dealership' | 'chase') => void;
  onLogout: () => void;
  children: React.ReactNode;
}

const GameLayout: React.FC<GameLayoutProps> = ({ user, onMenuClick, onLogout, children }) => {
  const isInJail = user.status === 'Jailed';

  return (
    <div className="game-layout">
      {/* Left Sidebar - Menu */}
      <div className="game-sidebar game-sidebar-left">
        <div className={`sidebar-header ${isInJail ? 'jail-logo' : ''}`}>
          {/* Prison bars overlay when in jail */}
          {isInJail && (
            <div 
              className="prison-bars"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: `
                  repeating-linear-gradient(
                    90deg,
                    transparent,
                    transparent 15px,
                    rgba(255, 255, 255, 0.4) 15px,
                    rgba(255, 255, 255, 0.4) 18px
                  ),
                  linear-gradient(
                    0deg,
                    transparent 0%,
                    transparent 10%,
                    rgba(255, 255, 255, 0.4) 10%,
                    rgba(255, 255, 255, 0.4) 12%,
                    transparent 12%,
                    transparent 88%,
                    rgba(255, 255, 255, 0.4) 88%,
                    rgba(255, 255, 255, 0.4) 90%,
                    transparent 90%
                  )
                `,
                pointerEvents: 'none',
                zIndex: 1
              }}
            />
          )}
          <div className="logo">
            <div 
              className="logo-image"
              style={{
                backgroundImage: 'url(/logo.svg)',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                width: '120px',
                height: '40px',
                position: 'relative'
              }}
            />
            <span className="logo-text fallback-hidden">NYC Mafia</span>
          </div>
        </div>
        
        <GameMenu user={user} onMenuClick={onMenuClick} />
        
        <div className="sidebar-footer">
          <button className="btn btn-danger w-100" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>

      {/* Main Content Area */}
      <div 
        className="game-main-content"
        style={{
          backgroundImage: 'url(/images/ui/backgrounds/bg.png)',
          backgroundRepeat: 'repeat',
          backgroundSize: 'auto',
          position: 'relative'
        }}
      >
        {/* Jail overlay for main content when in jail */}
        {isInJail && (
          <div 
            className="jail-overlay"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: `
                repeating-linear-gradient(
                  90deg,
                  transparent,
                  transparent 20px,
                  rgba(255, 255, 255, 0.1) 20px,
                  rgba(255, 255, 255, 0.1) 25px
                )
              `,
              pointerEvents: 'none',
              zIndex: 1
            }}
          />
        )}
        
        <div style={{ position: 'relative', zIndex: 2 }}>
          {children}
        </div>
      </div>

      {/* Right Sidebar - User Profile */}
      <div className="game-sidebar game-sidebar-right">
        <UserProfile user={user} />
      </div>
    </div>
  );
};

export default GameLayout;
